// POS-I184: a throttled request (429) shows one calm notice with the wait in minutes.
// Same wording rule as the API: under 90 seconds say "a minute".

/** Minutes to show, or 'one' for "a minute" (under 90 seconds). */
export function throttleWait(seconds: number): { kind: 'one' } | { kind: 'many'; minutes: number } {
  if (seconds < 90) return { kind: 'one' };
  return { kind: 'many', minutes: Math.ceil(seconds / 60) };
}

/** POS-I236: the wait belongs to one sign-in key (business + email); a different key is not throttled. */
export interface LoginThrottle {
  seconds: number;
  until: number;
  key: string;
}

export function loginThrottleKey(tenantSlug: string | undefined, email: string | undefined): string {
  return `${(tenantSlug ?? '').trim().toLowerCase()}|${(email ?? '').trim().toLowerCase()}`;
}

/** True only while the wait for this exact key has not passed. */
export function isLoginThrottled(throttle: LoginThrottle | null, key: string, now: number): boolean {
  return throttle !== null && throttle.key === key && now < throttle.until;
}
